import styled from '@emotion/styled';
import { useSurveyForm } from './useSurveyForm';
import { ActionButton } from 'ui/components/elements/ActionButton/ActionButton';
import { SnackBar } from 'ui/components/elements/SnackBar/SnackBar';
import { SurveyQuestion } from './SurveyQuestion';
import { PageTitle } from 'ui/components/elements/PageTitle/PageTitle';
import { mqUser } from 'utils/responsive';

const Wrapper = styled.div`
    padding: 18px 50px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    text-align: left;
    background-color: #f8f9fd;
    height: auto;
    min-height: calc(100vh - var(--height-pc-header));

    ${mqUser('SP')} {
        padding: 18px 15px;
    }
`;

const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 40px 40px 20px 40px;
    border-radius: 10px;
    background-color: var(--white);
    max-width: 800px;
    width: 100%;
    margin: 0 auto;
`;

const ButtonContainer = styled.div`
    margin: 0 auto;
    padding-bottom: 20px;
`;

export const SurveyForm: React.FC = () => {
    const { showSnackbar, setShowSnackbar, survey, loading, setValue, register, errors, onSubmit } = useSurveyForm();
    if (!survey) return null;
    return (
        <Wrapper>
            <SnackBar message="回答を送信しました" open={showSnackbar} setOpen={setShowSnackbar} />
            <PageTitle title="面談アンケート" />
            <FormContainer>
                {survey.question_data.map((question, index) => (
                    <SurveyQuestion
                        key={question.id}
                        index={index + 1}
                        question={question}
                        errors={errors}
                        register={register}
                        setValue={setValue}
                    />
                ))}
                <ButtonContainer>
                    <ActionButton
                        disabled={loading}
                        onClick={onSubmit}
                        bgColor="main-color-blue"
                        style={{ minWidth: '200px', maxWidth: '400px' }}
                    >
                        送信する
                    </ActionButton>
                </ButtonContainer>
            </FormContainer>
        </Wrapper>
    );
};
